import React, { useState } from 'react';
import { fmtCompact, fmtCostCompact, fmtCostExact } from '../utils/format';

// Renders a compact token count (e.g. 1.5M) with a polished tooltip on hover
// showing the exact number. The tooltip is pinned to the viewport (position:
// fixed) and follows the cursor, so it is never clipped by the surrounding
// `overflow-x-auto` table container.
export function TokenValue({ value, unit = 'tokens', currency = false }) {
  const n = Number(value) || 0;
  const [pos, setPos] = useState(null);

  const display = currency ? fmtCostCompact(n) : fmtCompact(n);
  const exact = currency ? fmtCostExact(n) : n.toLocaleString();
  const label = currency ? '' : unit;

  const track = (e) => setPos({ x: e.clientX, y: e.clientY });

  return (
    <span
      className="cursor-default"
      onMouseEnter={track}
      onMouseMove={track}
      onMouseLeave={() => setPos(null)}
    >
      {display}
      {pos && (
        <span
          role="tooltip"
          className="fixed z-[9999] pointer-events-none -translate-x-1/2 whitespace-nowrap
                     rounded-lg bg-panel/95 backdrop-blur border border-panel-border
                     px-2.5 py-1.5 text-xs font-medium text-fg shadow-xl
                     animate-in fade-in zoom-in-95 duration-100"
          style={{ left: pos.x, top: pos.y + 18 }}
        >
          {exact}
          {label && <span className="text-fg-muted ml-1">{label}</span>}
          {/* little arrow pointing up at the number above */}
          <span
            className="absolute left-1/2 bottom-full -translate-x-1/2 -mb-px
                       border-[5px] border-transparent border-b-panel-border"
          />
        </span>
      )}
    </span>
  );
}
